import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';
import { TeamSelectorModal } from './TeamSelectorModal';

interface TeamSelection {
  teamName: string;
  teamId?: string; // Team externalId (for grading_data)
  teamAbbr: string;
  teamLogoUrl: string;
  sport: string;
  teamMarket?: string; // City/market name (e.g., "Washington" for "Washington Wizards")
}

interface TeamPickerButtonProps {
  onSelect: (selection: TeamSelection) => void;
  selectedTeams: string[];
  fieldLabel?: string;
  disabled?: boolean;
  /** When set, auto-selects this league and disables the league selector in the modal */
  restrictedLeagueId?: string;
  /** Contest League IP flag — drives licensed vs generic image auto-fill */
  leagueIp?: boolean;
}

export function TeamPickerButton({
  onSelect,
  selectedTeams,
  fieldLabel,
  disabled = false,
  restrictedLeagueId,
  leagueIp = false,
}: TeamPickerButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setModalOpen(true)}
        disabled={disabled}
        className="shrink-0"
        title={'Select team'}
      >
        <Users className="h-4 w-4" />
      </Button>
      <TeamSelectorModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSelect={onSelect}
        selectedTeams={selectedTeams}
        fieldLabel={fieldLabel}
        restrictedLeagueId={restrictedLeagueId}
        leagueIp={leagueIp}
      />
    </>
  );
}
